'use strict';

exports.__esModule = true;
exports.lastUsedConnection = lastUsedConnection;
exports.lastUsedUsername = lastUsedUsername;

var _immutable = require('immutable');

function lastUsedConnection(m) {
  return m.getIn(['sso', 'lastUsedConnection']);
}

function lastUsedUsername(m) {
  return m.getIn(['sso', 'lastUsedUsername'], '');
}



//////////////////
// WEBPACK FOOTER
// ./~/auth0-lock/lib/core/sso/index.js
// module id = 87
// module chunks = 0